import React from 'react';

const Alert = ({ className }) => (
  <svg id="Alert" xmlns="http://www.w3.org/2000/svg" className="w-full" className={className} viewBox="0 0 250 250">
    <title>Alert</title>
    <path d="M191.76,191.46H58.24a8.64,8.64,0,0,1-7.48-13L117.52,62.86a8.64,8.64,0,0,1,15,0L199.24,178.5a8.64,8.64,0,0,1-7.48,13ZM121,64.86,54.22,180.5a4.64,4.64,0,0,0,4,7H191.76a4.64,4.64,0,0,0,4-7L129,64.86a4.64,4.64,0,0,0-8,0Z" fill="#ffb600"/>
    <path d="M129.15,105.4,127,144.83a2,2,0,0,1-4,0l-2.15-39.43a4.16,4.16,0,1,1,8.3-.45A3.38,3.38,0,0,1,129.15,105.4Z" fill="#0068ff"/>
    <circle cx="125" cy="162.6" r="4.53" fill="#0068ff"/>
  </svg>
);

export default Alert;
